import React, { useState, useEffect, useCallback } from "react";
import { Select, Spin } from "antd";
import axios from "axios";
import { Error } from "./Messages/Messages";

import { useTranslation } from "react-i18next";
const UserSearchComponent = ({
  value,
  onChange,
  placeholder = "Search and select users...",
  apiUrl,
  mode = "multiple",
  disabled = false,
  style = {}
}) => {
  const { t } = useTranslation("dashboard");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  // Debounced search function
  const searchUsers = useCallback(
    async query => {
      if (!query || query.trim().length < 4) {
        setSearchResults([]);
        return;
      }

      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/users/search`, {
          params: { query: query.trim() },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        });

        const users = response.data.results || [];

        // Format users for Select component
        const formattedUsers = users.map(user => ({
          label: `${user.firstName} ${user.lastName} (${user.email}) - ${user.userType}`,
          value: user.email,
          user: user
        }));

        setSearchResults(formattedUsers);
      } catch (error) {
        console.error("Search error:", error);
        Error("Failed to search users");
        setSearchResults([]);
      } finally {
        setLoading(false);
      }
    },
    [apiUrl]
  );

  // Debounce search calls
  useEffect(() => {
    const delayedSearch = setTimeout(() => {
      searchUsers(searchValue);
    }, 500);

    return () => clearTimeout(delayedSearch);
  }, [searchValue, searchUsers]);

  const handleSearch = value => {
    setSearchValue(value);
  };

  const handleChange = (selectedValues, options) => {
    onChange(selectedValues, options);
  };

  const handleClear = () => {
    setSearchResults([]);
    setSearchValue("");
  };

  return (
    <Select
      mode={mode}
      value={value}
      placeholder={placeholder}
      showSearch
      filterOption={false}
      onSearch={handleSearch}
      onChange={handleChange}
      onClear={handleClear}
      loading={loading}
      disabled={disabled}
      style={style}
      notFoundContent={
        loading ? (
          <div style={{ textAlign: "center", padding: "10px" }}>
            <Spin size="small" /> {t("Searching...")}
          </div>
        ) : searchValue && searchValue.length >= 2 ? (
          <div style={{ textAlign: "center", padding: "10px", color: "var(--ds-text-muted)" }}>
            No users found for "{searchValue}"
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "10px", color: "var(--ds-text-muted)" }}>
            {t("Type at least 4 characters to search")}
          </div>
        )
      }
      options={searchResults}
      optionFilterProp="label"
    />
  );
};

export default UserSearchComponent;
